// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validation-errors {
    margin: 5px 10px;
}

ul {
    margin: 5px 0;
}

.validation-error-indicator {
    color: #a83e0b;
}

.validation-error {
    margin-right: 10px;
    vertical-align: middle;
    font-size: 0.9em;
}
.validation-error a {
    text-decoration: none;
    color: #430c00;
}

.validation-error a > .material-symbols-outlined {
    color: var(--primary-color);
    position: relative;
    top: -2px;
}

.more-validation-errors-indicator {
    cursor: pointer;
    font-size: 0.85em;
    color: #555;
    text-decoration: underline;
    font-style: italic;
}

.validation-errors > span {
    vertical-align: middle;
}

.validation-errors .material-symbols-outlined {
    vertical-align: middle;
    font-size: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/EnrolmentValidationErrors/EnrolmentValidationErrors.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB","sourcesContent":[".validation-errors {\n    margin: 5px 10px;\n}\n\nul {\n    margin: 5px 0;\n}\n\n.validation-error-indicator {\n    color: #a83e0b;\n}\n\n.validation-error {\n    margin-right: 10px;\n    vertical-align: middle;\n    font-size: 0.9em;\n}\n.validation-error a {\n    text-decoration: none;\n    color: #430c00;\n}\n\n.validation-error a > .material-symbols-outlined {\n    color: var(--primary-color);\n    position: relative;\n    top: -2px;\n}\n\n.more-validation-errors-indicator {\n    cursor: pointer;\n    font-size: 0.85em;\n    color: #555;\n    text-decoration: underline;\n    font-style: italic;\n}\n\n.validation-errors > span {\n    vertical-align: middle;\n}\n\n.validation-errors .material-symbols-outlined {\n    vertical-align: middle;\n    font-size: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
